<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div class="row">
				<div class="col-3">
					<form class="ts-h-full">
						<fieldset class="ts-h-full">
							<legend>{{ $t('yearlyPaymentList.criteria') }}</legend>
							<div class="row form-group">
								<div class="col-md-12">
									<label class="required">{{
										$t('yearlyPaymentList.branchName')
									}}</label>
									<a-select style="width: 100%" v-model.number="model.branch_id" :options="branches"></a-select>
									<div class="validate" v-if="errors.has('branch_id')">
										{{ errors.first('branch_id') }}
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<label class="required">{{
										$t('yearlyPaymentList.acYear')
									}}</label>
									<a-select style="width: 100%" v-model.number="model.ac_year_id" :options="ac_year_list"></a-select>
									<div class="validate" v-if="errors.has('ac_year_id')">
										{{ errors.first('ac_year_id') }}
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<label>{{ $t('yearlyPaymentList.feeType') }}</label>
									<a-select v-model="model.fee_type_id" class="ts-w-full" :options="feeTypes" @change="onFeeTypeChange"
										allowClear></a-select>
								</div>
							</div>
							<div class="row form">
								<div class="col-md-12">
									<div class="ts-flex ts-justify-between">
										<label class="required">{{ $t('yearlyPaymentList.feeName') }}</label>
										<ts-checkbox @change="selectAllFeeSetupItem">All</ts-checkbox>
									</div>
									<a-select v-model="model.fee_setup_id" mode="multiple" class="ts-w-full" allowClear
										:options="feeSetups" :limit="1" :maxTagCount="1" :filter-option="(input, option) =>
												option.componentOptions.children[0].text
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											"></a-select>
									<div class="validate" v-if="errors.has('fee_setup_id')">
										{{ errors.first('fee_setup_id') }}
									</div>
								</div>
							</div>
							<div class="row ts-mt-4">
								<div class="col-md-12 text-right">
									<ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting">{{
										$t('preview') }}</ts-button>
								</div>
							</div>
						</fieldset>
					</form>
				</div>
				<div class="col-md-9">
					<form>
						<fieldset>
							<legend>{{ $t('yearlyPaymentList.previewPdf') }}</legend>
							<ts-preview-pdf v-model="waiting" :src="src" />
						</fieldset>
					</form>
				</div>
			</div>
		</ts-loading-banner>
	</div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
	name: 'yearlyPaymentListByService',
	data() {
		return {
			loading: false,
			waiting: false,
			exporting: false,
			src: '',
			errors: new Errors(),
			feeTypes: [],
			ac_year_list: [],
			branches: [],
			feeSetups: [],
			model: {
				report_type: 'en',
				branch_id: null,
				ac_year_id: null,
				fee_type_id: null,
				fee_setup_id: [],
				status: ['Active']
			}
		}
	},
	created() {
		this.fetchData()
	},
	computed: {
		status() {
			return this.$store.state.reportPayment.studentStatus
		}
	},
	methods: {
		...mapActions('reportPayment', [
			'getBranch',
			'yearlyPaymentList',
			'getYear',
			'getStudentStatus',
			'fetchFeeType',
			'fetchFeeSetup'
		]),
		async fetchData() {
			this.loading = true
			await this.getStudentStatus()
			await this.getBranch().then(response => {
				this.branches = response.data.map(el => ({
					value: el.branch_id,
					label: el.branch_name_en
				}))
				this.model.branch_id = this.$store.state.authUser.default_branch_id
			})
			await this.fetchFeeType().then(re => {
				this.feeTypes = re.data.map(el => ({
					value: el.fee_type_id,
					label: el.fee_type_name
				}))
			})
			this.loading = false
		},
		onBranchChange() {
			this.model.ac_year_id = null
			this.model.acps_id = []
			this.model.ac_term_id = []
			this.model.class_id = []
			this.model.fee_type_id = null
			this.model.fee_setup_id = []
			this.feeSetups = []
			this.fetching = true
			this.getYear({
				filter: {
					ac_status_id: '1,2,3',
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
						el => ({
							value: el.ac_year_id,
							label:
								el.ac_year +
								(el.ac_status_id == 1
									? ' ( Current ) '
									: el.ac_status_id == 2
										? ' ( History ) '
										: ' ( Next ) ')
						})
					)
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.fetching = false
				})
		},
		onFeeTypeChange(feeTypeId) {
			this.feeSetups = []
			this.model.fee_setup_id = []
			if (!feeTypeId) return
			this.loading = true
			this.fetchFeeSetup({
				fee_type_id: [feeTypeId],
				branch_id: [this.model.branch_id],
				ac_term_id: this.model.ac_term_id
			})
				.then(re => {
					this.feeSetups = re.data.map(el => ({
						value: el.fee_setup_id,
						label: `${el.prefix}-${el.fee_name_en}`
					}))
				})
				.finally(() => {
					this.loading = false
				})
		},
		preview() {
			this.waiting = true
			this.src = ''
			this.errors = new Errors()
			this.yearlyPaymentList(this.model)
				.then(response => {
					this.src = response.url
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		selectAllFeeSetupItem(value) {
			if (value) {
				this.feeSetups.forEach(el => {
					this.model.fee_setup_id.push(el.value)
				})
			} else {
				this.model.fee_setup_id = []
			}
		},
	},
	watch: {
		'model.branch_id': function (val) {
			if (val) {
				this.onBranchChange()
			}
		}
	}
}
</script>
